module.exports = __webpack_public_path__ + "static/media/libraryBooks.efc3498d.png";